// Angular
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SplashScreenService } from './splash-screen.service';
import { environment } from './../../../environments/environment';
// Object-Path

@Component({
    selector: 'kt-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss'],
    standalone: false
})
export class SplashScreenComponent implements OnInit {
	// Public proprties
	loaderLogo: string;
	loaderType: string;
	loaderMessage: string;

	@ViewChild('splashScreen', { static: true }) splashScreen: ElementRef;

	/**
	 * Component constructor
	 *
	 * @param splashScreenService: SplachScreenService
	 */
	constructor(
		private splashScreenService: SplashScreenService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	loaderLogoPath: string = './assets/media/logos/plus_physio_Logo.png';
	ngOnInit() {
		// init splash screen, see loader option in layout.config.ts
		// const loaderConfig = this.layoutConfigService.getConfig('loader');
		const domain = window.location.hostname;
		if (domain.includes('plus-doctor.com') || environment.environmentType === 'plusdoctor') {
			this.loaderLogo = './assets/media/logos/PlusDoctorLogo.png';
		} else if (domain.includes('plusradiology.ai') || environment.environmentType === 'plusradiology') {
			this.loaderLogo = './assets/media/logos/Plus-Radiology.png';
		} else {
			this.loaderLogo = './assets/media/logos/plus_physio_Logo.png';
		}
		this.loaderType = 'spinner-logo'
		this.loaderMessage = 'Please wait...'
		this.splashScreenService.init(this.splashScreen);
	}
}
